export const en = {
  'app.name': 'Mendikot',
  'app.tagline': 'The classic Indian game of tens',

  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.continue': 'Continue',
  'common.loading': 'Loading…',
  'common.save': 'Save',
  'common.or': 'or',
  'common.edit': 'Edit',
  'common.more': 'More variants',
  'common.beta': 'Beta',

  'home.greeting': 'Namaste, {{name}}',
  'home.playFriends': 'Play with friends',
  'home.playFriendsDesc': 'Private table · invite with a code',
  'home.practice': 'Practice vs bots',
  'home.practiceDesc': 'Offline · at your own pace',
  'home.join': 'Join with a code',
  'home.howTo': 'How to play',
  'home.continueGame': 'Return to your table',
  'home.onlineUnavailable': 'Online play needs a Firebase project — practice is ready to go.',

  'create.title': 'Set up the table',
  'create.practiceTitle': 'Practice table',
  'create.players': 'Players',
  'create.trump': 'Trump',
  'create.trump.CUT': 'Cut (Katte)',
  'create.trump.CUT.desc':
    'The first player who can’t follow suit sets trump with the card they play.',
  'create.trump.BAND_A_AUTO': 'Hidden (Band)',
  'create.trump.BAND_A_AUTO.desc':
    'The player right of the dealer hides a card. Its suit becomes trump the first time someone can’t follow suit.',
  'create.trump.BAND_B_REQUEST': 'Hidden · on request',
  'create.trump.BAND_B_REQUEST.desc':
    'Like Hidden, but a player who can’t follow suit chooses whether to reveal it.',
  'create.trump.RANDOM_OPEN': 'Open trump',
  'create.trump.RANDOM_OPEN.desc': 'A random trump suit is shown before the deal.',
  'create.target': 'Match length',
  'create.targetValue': 'First to {{n}}',
  'create.timer': 'Turn timer',
  'create.timerValue': '{{n}}s',
  'create.timerOff': 'Off',
  'create.difficulty': 'Bot skill',
  'create.create': 'Create table',
  'create.deal': 'Deal cards',
  'create.name': 'Your name',

  'difficulty.easy': 'Relaxed',
  'difficulty.normal': 'Sharp',

  'join.title': 'Join a table',
  'join.code': 'Room code',
  'join.submit': 'Take a seat',
  'join.invalid': 'Enter the 6-character code',

  'lobby.title': 'Table {{code}}',
  'lobby.share': 'Invite friends',
  'lobby.copy': 'Copy link',
  'lobby.copied': 'Invite link copied',
  'lobby.whatsapp': 'WhatsApp',
  'lobby.shareShort': 'Share',
  'lobby.partners': 'Teams alternate around the table — your partner sits opposite.',
  'lobby.shareText': 'Join my Mendikot table! Code {{code}}',
  'lobby.waiting': 'Waiting for players…',
  'lobby.ready': 'I’m ready',
  'lobby.notReady': 'Not ready',
  'lobby.isReady': 'Ready',
  'lobby.start': 'Start match',
  'lobby.addBot': 'Add bot',
  'lobby.removeBot': 'Remove bot',
  'lobby.emptySeat': 'Open seat',
  'lobby.takeSeat': 'Sit here',
  'lobby.host': 'Host',
  'lobby.you': 'You',
  'lobby.team': 'Team {{team}}',
  'lobby.rules': 'Table rules',
  'lobby.leave': 'Leave table',
  'lobby.needAll': 'Fill every seat and get everyone ready to start.',
  'lobby.hostWillStart': 'The host will start the match.',

  'table.yourTurn': 'Your turn',
  'table.waitingFor': '{{name}} is thinking…',
  'table.reserveTitle': 'Hide a trump card',
  'table.reserveHint':
    'Pick one card. Its suit becomes trump when someone first can’t follow suit.',
  'table.reserveWaiting': '{{name}} is hiding a trump card…',
  'table.trump': 'Trump',
  'table.trumpHidden': 'Hidden',
  'table.trumpNone': 'Not set',
  'table.tens': 'Tens',
  'table.tricks': 'Tricks',
  'table.led': 'Led',
  'table.hand': 'Hand {{n}}',
  'table.score': 'Hands',
  'table.revealRequest': 'Reveal trump',
  'table.nudge': 'Nudge',
  'table.nudged': 'Nudged',
  'table.bot': 'Bot',
  'table.away': 'Away',
  'table.you': 'You',
  'table.partner': 'Partner',
  'table.dealer': 'Dealer',
  'table.hiddenTrump': 'Your hidden trump',
  'table.menu': 'Menu',
  'table.lastTrick': 'Last trick',
  'table.leave': 'Leave match',

  'illegal.MUST_FOLLOW_SUIT': 'Follow {{suit}}',
  'illegal.NOT_YOUR_TURN': 'Wait for your turn',
  'illegal.CARD_RESERVED': 'Your hidden trump',
  'illegal.MUST_PLAY_TRUMP': 'Play a trump',
  'illegal.default': 'Can’t play this now',

  'event.trumpSet': '{{name}} cut — {{suit}} is trump!',
  'event.trumpRevealed': 'Trump revealed: {{suit}}',
  'event.autoPlayed': 'Time’s up — a card was played for {{name}}',
  'event.botTakeover': 'A bot is holding {{name}}’s seat',
  'event.playerReturned': '{{name}} is back',
  'event.trickWon': '{{name}} takes the trick',

  'result.win': 'Your team takes the hand!',
  'result.loss': 'The other team takes this hand',
  'result.draw': 'Drawn hand — redeal',
  'result.coat': 'Mendikot!',
  'result.coatDesc': 'All the tens captured',
  'result.whitewash': 'Whitewash!',
  'result.whitewashDesc': 'Every single trick',
  'result.tens': 'Tens',
  'result.tricks': 'Tricks',
  'result.next': 'Next hand',
  'result.seeMatch': 'See match result',
  'result.nextIn': 'Next hand in {{n}}s',
  'result.nextDealer': '{{name}} deals next',
  'result.waiting': 'Waiting for others…',

  'match.won': 'Match won!',
  'match.lost': 'Match lost',
  'match.final': 'Final score {{a}} – {{b}}',
  'match.rematch': 'Rematch',
  'match.backToLobby': 'Back to lobby',
  'match.home': 'Home',
  'match.playAgain': 'Play again',
  'match.botAssisted': 'Bots helped at {{seats}}',

  'suit.S': 'Spades',
  'suit.H': 'Hearts',
  'suit.D': 'Diamonds',
  'suit.C': 'Clubs',
  'team.A': 'A',
  'team.B': 'B',
  'team.us': 'Us',
  'team.them': 'Them',

  'auth.title': 'Save your progress',
  'auth.subtitle': 'Keep your stats and seat across devices.',
  'auth.google': 'Continue with Google',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.displayName': 'Name',
  'auth.signIn': 'Sign in',
  'auth.signUp': 'Create account',
  'auth.switchToSignUp': 'New here? Create an account',
  'auth.switchToSignIn': 'Have an account? Sign in',
  'auth.signOut': 'Sign out',
  'auth.forgot': 'Forgot password?',
  'auth.resetSent': 'Password reset email sent',
  'auth.openInBrowser':
    'Google sign-in is blocked inside this app. Open the page in your browser to use it.',
  'auth.guestNote': 'You’re playing as a guest',
  'auth.verifySent': 'Check your inbox to verify your email',

  'settings.title': 'Settings',
  'settings.gameplay': 'Gameplay',
  'settings.sound': 'Sound effects',
  'settings.haptics': 'Vibration',
  'settings.reducedMotion': 'Reduce motion',
  'settings.fourColor': 'Four-colour deck',
  'settings.language': 'Language',
  'settings.notifications': 'Notifications',
  'settings.notificationsDesc': 'Turn reminders and table alerts',
  'settings.analytics': 'Share usage data',
  'settings.account': 'Account',
  'settings.deleteAccount': 'Delete account',
  'settings.deleteConfirm': 'Delete your account and stats permanently?',
  'settings.theme': 'Festival theme',
  'settings.themeAuto': 'Follow festival calendar',

  'profile.title': 'Profile',
  'profile.games': 'Matches',
  'profile.wins': 'Wins',
  'profile.coats': 'Mendikots',
  'profile.whitewashes': 'Whitewashes',

  'push.title': 'Never miss your turn',
  'push.body': 'Get a nudge when it’s your turn or your table is ready.',
  'push.enable': 'Turn on',
  'push.later': 'Not now',
  'push.iosHint': 'On iPhone, add Mendikot to your Home Screen to get notifications.',

  'pwa.install': 'Install app',
  'pwa.installDesc': 'Full-screen play and offline practice.',

  'connection.offline': 'You’re offline',
  'connection.reconnecting': 'Reconnecting…',

  'error.ROOM_FULL': 'This table is full',
  'error.NO_SUCH_CODE': 'No table with that code',
  'error.ROOM_IN_PROGRESS': 'That match has already started',
  'error.ROOM_CLOSED': 'This table has closed',
  'error.NOT_HOST': 'Only the host can do that',
  'error.NOT_READY': 'Everyone must be ready first',
  'error.SEATS_EMPTY': 'Fill every seat first',
  'error.STALE_VERSION': 'The table moved on — try again',
  'error.RATE_LIMITED': 'Slow down a little and try again',
  'error.UNAVAILABLE': 'Online play isn’t configured yet',
  'error.NETWORK': 'Connection problem — try again',
  'error.default': 'Something went wrong',

  'theme.default': 'Royal',
  'theme.diwali': 'Diwali',
  'theme.holi': 'Holi',
  'theme.navratri': 'Navratri',
  'theme.durga_puja': 'Durga Puja',
  'theme.ganesh_chaturthi': 'Ganesh Chaturthi',
  'theme.onam': 'Onam',
  'theme.pongal_sankranti': 'Pongal & Sankranti',
  'theme.raksha_bandhan': 'Raksha Bandhan',
  'theme.independence_day': 'Independence Day',
  'theme.republic_day': 'Republic Day',
  'theme.eid': 'Eid',
  'theme.christmas_newyear': 'Christmas & New Year',

  'greeting.default': 'Gather your four. Capture the tens.',
  'greeting.diwali': 'Shubh Deepavali! Light up the table.',
  'greeting.holi': 'Happy Holi! Play in full colour.',
  'greeting.navratri': 'Shubh Navratri! Nine nights, many hands.',
  'greeting.durga_puja': 'Shubho Pujo! A festive table awaits.',
  'greeting.ganesh_chaturthi': 'Ganpati Bappa Morya!',
  'greeting.onam': 'Happy Onam! Gather the family.',
  'greeting.pongal_sankranti': 'Happy Sankranti! Kites up, cards out.',
  'greeting.raksha_bandhan': 'Happy Raksha Bandhan!',
  'greeting.independence_day': 'Happy Independence Day! Jai Hind.',
  'greeting.republic_day': 'Happy Republic Day!',
  'greeting.eid': 'Eid Mubarak!',
  'greeting.christmas_newyear': 'Season’s greetings! One more hand?',

  'howto.title': 'How to play',
  'howto.goal.title': 'Capture the tens',
  'howto.goal.body':
    'Four players, two teams. Partners sit opposite. The team that captures more of the four 10s wins the hand — all four is a Mendikot!',
  'howto.play.title': 'Follow suit',
  'howto.play.body':
    'The player right of the dealer leads. Everyone must play the led suit if they can. The highest card of the led suit wins — unless a trump is played.',
  'howto.cut.title': 'Cut sets the trump',
  'howto.cut.body':
    'In Cut mode, the first player who can’t follow suit plays any card — and its suit becomes trump for the rest of the hand.',
  'howto.band.title': 'Hidden trump',
  'howto.band.body':
    'In Hidden mode, a trump card is hidden before play. It’s revealed the first time someone can’t follow suit.',
  'howto.score.title': 'Winning',
  'howto.score.body':
    'Most tens wins the hand. With two tens each, the team with more tricks wins. Taking all 13 tricks is a Whitewash.',
  'howto.start': 'Start a practice game',

  'settings.privacy': 'Privacy & data',
  'settings.downloadData': 'Download my data',
  'settings.downloadDone': 'Your data file is downloading',
  'settings.privacyPolicy': 'Privacy policy',
  'gate.title': 'Before you play',
  'gate.age': 'Mendikot is for players aged 18 and over.',
  'gate.noticeIntro': 'What we use, and why:',
  'gate.item.game':
    'A guest ID, your nickname, avatar and games — to run your tables and keep your stats.',
  'gate.item.account': 'Your email or Google name — only if you sign in to save your progress.',
  'gate.item.push': 'A notification token — only if you turn on reminders.',
  'gate.item.security': 'Security checks by Google reCAPTCHA — to keep bots out.',
  'gate.item.analytics':
    'Usage, performance and crash data linked to a random ID, never your name or email — only if you allow it.',
  'gate.rights': 'Download or delete your data and change your choice any time in Settings.',
  'gate.policy': 'Privacy policy',
  'gate.playShare': 'I’m 18+ · Allow usage data',
  'gate.playNoShare': 'I’m 18+ · Don’t share',
  'gate.under18': 'I’m under 18',
  'gate.blockedTitle': 'Sorry, you need to be 18',
  'gate.blockedBody': 'Mendikot is only for players aged 18 and over.',
  'gate.blockedBack': 'I made a mistake',
  'privacy.title': 'Privacy policy',
  'privacy.languageNote':
    'This policy is in English. Email us for a copy in Hindi, Gujarati, Marathi or another Indian language.',
} as const;

export type MessageKey = keyof typeof en;
export type Messages = Record<MessageKey, string>;
